import React, {
  createContext,
  useContext,
  useCallback,
  useState
} from "react";
import integrationsService from "../services/integrations.service";
import type { ApiTypes } from "cuvama-api";

interface IntegrationsState {
  [name: string]: ApiTypes.Integration | null;
}

interface IntegrationsContextType {
  integrations: IntegrationsState;
  refreshIntegration: (name: string) => Promise<void>;
}

export const IntegrationsContext = createContext<IntegrationsContextType>({
  integrations: {},
  refreshIntegration: async () => {}
});

interface IntegrationsProviderProps {
  children: React.ReactNode;
}

const IntegrationsProvider = ({ children }: IntegrationsProviderProps) => {
  const [integrations, setIntegrations] = useState<IntegrationsState>({});

  const refreshIntegration = useCallback(async (name: string) => {
    const data = await integrationsService.getIntegration({ name });
    setIntegrations((prev) => ({
      ...prev,
      [name]: data && Object.keys(data).length > 0 ? data : null
    }));
  }, []);

  return (
    <IntegrationsContext.Provider
      value={{ integrations, refreshIntegration }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
};

export const useIntegration = (
  name: string
): ApiTypes.Integration | null => {
  const { integrations } = useContext(IntegrationsContext);
  return integrations[name] ?? null;
};

export default IntegrationsProvider;
